import { html, nothing } from "lit";
import type { ChannelAccountSnapshot } from "../types.ts";
import type { ChannelsProps } from "./channels.types.ts";
import { channelStatusChip, channelMeta } from "./channels.shared.ts";

/**
 * Email channel card.
 *
 * Email is configured per-agent (see the dedicated Email view), so this card
 * surfaces the live IMAP polling status for the currently selected agent and
 * links through to the full configuration rather than duplicating it.
 */
export function renderEmailCard(params: {
  props: ChannelsProps;
  emailAccounts: ChannelAccountSnapshot[];
  accountCountLabel: unknown;
}) {
  const { props, accountCountLabel } = params;
  const status = props.emailStatus;

  return html`
    <div class="card">
      <div class="chan-head">
        <div>
          <div class="card-title">Email</div>
          <div class="card-sub">IMAP inbox polling, configured per agent.</div>
        </div>
        ${
          status
            ? channelStatusChip({ running: status.running, connected: status.connected })
            : nothing
        }
      </div>
      ${accountCountLabel}

      ${
        status
          ? html`
            ${channelMeta([
              { k: "Polls", v: String(status.pollCount) },
              { k: "Messages", v: String(status.messagesReceived) },
              {
                k: "Interval",
                v: status.pollIntervalMs > 0 ? `${status.pollIntervalMs / 1000}s` : null,
              },
              {
                k: "Last poll",
                v: status.lastPollAt ? new Date(status.lastPollAt).toLocaleString() : null,
              },
            ])}
            ${
              status.lastPollError
                ? html`<div class="callout danger" style="margin-top: 12px;">
                    ${status.lastPollError}
                  </div>`
                : nothing
            }
          `
          : html`<div class="chan-meta"><span class="chan-meta__item">Open Email settings to view per-agent status</span></div>`
      }

      <div class="row" style="margin-top: 16px;">
        <button
          class="btn"
          @click=${() => props.onManageEmail?.()}
          ?disabled=${!props.onManageEmail}
        >
          Manage email accounts →
        </button>
      </div>
    </div>
  `;
}
